// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3ceIA","emails":"CreateEditClinics_emails__A0ru0","emailTagLabel":"CreateEditClinics_emailTagLabel__2N3cp"};